<template lang="pug">
	.v-field-double-text.field-double-text
		label.field-label(v-if="field.label && field.mode !== 'no-label'" :for="uniqueId")
			| {{field.label}}
			span.field-text__star(v-if="field.required") *
		.field-double-text__field
			.field-double-text__cell
				v-field(:field="{value: from,...field.firstField}" v-model="from" @update:model-value="handleInput")
			.field-double-text__between(v-if="field.variables" ) {{ field.variables?.between || '' }}
			.field-double-text__cell
				v-field(:field="{value: to,...field.secondField}" v-model="to"  @update:model-value="handleInput")
</template>


<script>
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {
	props: {
		field: {
			type: Object,
			required: true,
			default: null
		},

		modelValue: {
			type: [Object, String, Number, Boolean],
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: null,
			from: null,
			to: null,
			uniqueId: uniqueId('field-')
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		},
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue;
			if(this.localValue.length) {
				const [
					first = null,
					second= null
				] = this.localValue;
				this.from = first;
				this.to = second;
			}
		},

		handleInput() {
			this.localValue = [this.from, this.to];
			this.$emit('update:model-value', this.localValue);
		}
	},
};
</script>